var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 64 64",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9733 5.33325C17.2533 5.33325 5.30664 17.2799 5.30664 31.9999C5.30664 46.7199 17.2533 58.6666 31.9733 58.6666C46.6933 58.6666 58.64 46.7199 58.64 31.9999C58.64 17.2799 46.6933 5.33325 31.9733 5.33325ZM41.6 22.2399C44.4533 22.2399 46.7466 24.5333 46.7466 27.3866C46.7466 30.2399 44.4533 32.5333 41.6 32.5333C38.7466 32.5333 36.4533 30.2399 36.4533 27.3866C36.4266 24.5333 38.7466 22.2399 41.6 22.2399ZM25.6 18.0266C29.0666 18.0266 31.8933 20.8533 31.8933 24.3199C31.8933 27.7866 29.0666 30.6133 25.6 30.6133C22.1333 30.6133 19.3066 27.7866 19.3066 24.3199C19.3066 20.8266 22.1066 18.0266 25.6 18.0266ZM25.6 42.3733V52.3733C19.2 50.3733 14.1333 45.4399 11.8933 39.1466C14.6933 36.1599 21.68 34.6399 25.6 34.6399C27.0133 34.6399 28.8 34.8533 30.6666 35.2266C26.2933 37.5466 25.6 40.6133 25.6 42.3733ZM31.9733 53.3333C31.2533 53.3333 30.56 53.3066 29.8666 53.2266V42.3733C29.8666 38.5866 37.7066 36.6933 41.6 36.6933C44.4533 36.6933 49.3866 37.7333 51.84 39.7599C48.72 47.6799 41.0133 53.3333 31.9733 53.3333Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.8fd9ed89ef7c80ed573850a27e2eaf8d.svg";
export { ForwardRef as ReactComponent };